import {
  BookOpen, CalendarCheck, CirclePlay, Flag, Flame, GraduationCap, Heart, Inbox, Medal, MessageCircle, MessageSquare,
  Newspaper, Route, Send, Shield, ShieldAlert, ShieldCheck, Target, UserPlus, Bell,
} from 'lucide-react';

/** Abas do sininho e da lateral da página. Gestão só aparece para admin e super admin. */
export const CATEGORIES = [
  { key: 'todas', label: 'Todas', icon: Inbox },
  { key: 'estudo', label: 'Estudo', icon: BookOpen },
  { key: 'trilhas', label: 'Trilhas', icon: Route },
  { key: 'artigos', label: 'Artigos', icon: Newspaper },
  { key: 'gestao', label: 'Gestão', icon: Shield, admin: true },
];

export const CATEGORY_LABEL = Object.fromEntries(CATEGORIES.map(c => [c.key, c.label]));

export const categoriesFor = (isAdmin) => CATEGORIES.filter(c => !c.admin || isAdmin);

/** Tipo → ícone e tom (navy, lime, amber, danger). */
export const TYPES = {
  COMMENT_REPLY: { icon: MessageCircle, tone: 'navy' },
  ARTICLE_LIKES: { icon: Heart, tone: 'danger' },
  TAG_NEW_ARTICLE: { icon: Newspaper, tone: 'lime' },
  ARTICLE_COMMENT: { icon: MessageSquare, tone: 'navy' },
  CHECKPOINT_DUE: { icon: Flag, tone: 'amber' },
  CHECKPOINT_LATE: { icon: Flag, tone: 'danger' },
  DAILY_PLAN: { icon: CalendarCheck, tone: 'navy' },
  STREAK_RISK: { icon: Flame, tone: 'amber' },
  ACHIEVEMENT: { icon: Medal, tone: 'lime' },
  COURSE_NEW_CONTENT: { icon: CirclePlay, tone: 'navy' },
  COURSE_ACCESS: { icon: GraduationCap, tone: 'lime' },
  EXAM_STALE: { icon: Target, tone: 'amber' },
  COMMENT_REPORTED: { icon: ShieldAlert, tone: 'danger' },
  ACCESS_REQUEST: { icon: UserPlus, tone: 'navy' },
  CONTENT_PUBLISHED: { icon: Send, tone: 'navy' },
  ARTICLE_REVIEW_PENDING: { icon: ShieldCheck, tone: 'amber' },
  ARTICLE_REVIEW_APPROVED: { icon: ShieldCheck, tone: 'lime' },
  ARTICLE_REVIEW_REJECTED: { icon: ShieldAlert, tone: 'danger' },
};

export const typeMeta = (type) => TYPES[type] || { icon: Bell, tone: 'navy' };

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

/** Hoje · Ontem · Esta semana · Mais antigas, na ordem em que os itens chegam (mais recentes primeiro). */
export function groupByDate(items, now = new Date()) {
  const today = startOfDay(now).getTime();
  const day = 24 * 60 * 60 * 1000;
  const label = (iso) => {
    const t = startOfDay(new Date(iso)).getTime();
    if (t >= today) return 'Hoje';
    if (t >= today - day) return 'Ontem';
    if (t >= today - 6 * day) return 'Esta semana';
    return 'Mais antigas';
  };
  const groups = [];
  for (const it of items) {
    const l = label(it.createdAt);
    const last = groups[groups.length - 1];
    if (last && last.label === l) last.items.push(it);
    else groups.push({ label: l, items: [it] });
  }
  return groups;
}

/** Hora para hoje e ontem; dia da semana na semana; data antes disso. */
export function timeLabel(iso, now = new Date()) {
  const d = new Date(iso);
  const hm = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const diff = (startOfDay(now) - startOfDay(d)) / (24 * 60 * 60 * 1000);
  if (diff <= 1) return hm;
  if (diff <= 6) return `${d.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '')}, ${hm}`;
  return d.toLocaleDateString('pt-BR', { day: 'numeric', month: 'short' }).replace('.', '').replace(' de ', ' ');
}

export const badgeCount = (n) => (n > 9 ? '9+' : String(n));
